import classnames from 'classnames';
import PropTypes from 'prop-types';
import styles from './banner-media.module.less';
import { getBlockComponentForContent } from '../../utils/cms-utils';
import BannerMedia from './BannerMedia';

const getVideoFromVideoLink = (link) => (
    <iframe src={link} frameBorder="0" allow="autoplay; fullscreen" allowFullScreen />
);

const BannerVideo = ({ title, text, video, link, theme, videoLink }) => {
    const videoComponent = videoLink ? getVideoFromVideoLink(videoLink) : getBlockComponentForContent({ data: video });
    const videoContainerClass = classnames(styles.videoContainer, theme?.style && styles[`style-${theme.style}`]);

    return (
        <BannerMedia title={title} text={text} link={link} theme={theme}>
            <div className={videoContainerClass}>{videoComponent}</div>
        </BannerMedia>
    );
};

BannerVideo.propTypes = {
    title: PropTypes.string,
    text: PropTypes.string,
    link: PropTypes.node,
};

BannerVideo.defaultProps = {
    children: null,
    link: null,
};

export default BannerVideo;
